
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6uENn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d303ddba53d82f5b367e7e70fa925a3f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ba5308424987150$var$_react = $4ba5308424987150$var$_interopRequireDefault((parcelRequire("42omo")));

var $4ba5308424987150$var$_baseNew = $4ba5308424987150$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4ba5308424987150$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CalendarPlus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Auto-scheduling in Jira Plans. Scheduled dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ba5308424987150$var$CalendarPlusIcon = (props)=>/*#__PURE__*/ $4ba5308424987150$var$_react.default.createElement($4ba5308424987150$var$_baseNew.default, Object.assign({
        name: "CalendarPlusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h4.5V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5v1H13a2 2 0 0 1 2 2v4.5zm9.75 4.75V10h1.5v2.25H16v1.5h-2.25V16h-1.5v-2.25H10v-1.5z" clip-rule="evenodd"/>`
    }, props));
$4ba5308424987150$var$CalendarPlusIcon.displayName = 'CalendarPlusIcon';
var $4ba5308424987150$var$_default = module.exports.default = $4ba5308424987150$var$CalendarPlusIcon;

});


//# sourceMappingURL=calendar-plus.435c4b76.js.map
